import React from "react";
import Loop from "../loop";
import PostBox from "../post-box";

export default Loop(PostBox);

